const ExcelLoader = require('./excel');

module.exports = {
    ExcelLoader
};